// components/TestErrorComponent.js
import React, { useEffect } from "react";

const TestErrorComponent = () => {
  useEffect(() => {
    throw new Error("Test error to trigger ErrorBoundary");
  }, []);

  return <div>This will never be rendered</div>;
};

export default TestErrorComponent;
